import { enumToLabel } from '@/utils/enum-to-label';

export enum SIMULATION_CALCULATION_TYPE_OPTIONS {
	FIXED = 1,
	STEP_UP,
	STEP_DOWN,
}

// Map enum to options array using enumToLabel
export const calculationTypeOptions = Object.keys(
	SIMULATION_CALCULATION_TYPE_OPTIONS,
)
	.filter((key) => isNaN(Number(key)))
	.map((key) => ({
		label: enumToLabel(key),
		value:
			SIMULATION_CALCULATION_TYPE_OPTIONS[
				key as keyof typeof SIMULATION_CALCULATION_TYPE_OPTIONS
			],
	}));

export enum SIMULATION_INSURANCE_TYPE {
	MTF_CLAUSE = 'Banker Clause - Penutupan Cover Asuransi oleh MTF',
	BANKER_CLAUSE = 'Banker Clause - Penutupan Cover Asuransi oleh Debitur',
	COMBINATION = 'Kombinasi',
	REKANAN = 'Banker Clause Rekanan BMRI/MTF',
}

export enum SIMULATION_ASSET_TYPE {
	PASSENGER = 'Passenger Car',
	COMMERCIAL = 'Commercial Car',
	HEAVY_EQUIPMENT = 'Heavy Equipment',
	MACHINE = 'Machinery',
	INVOICE = 'Invoice',
	MOTOR = 'Motor',
}

export enum SIMULATION_ASSET_CONDITION {
	USED = 1,
	NEW = 2,
}
